import React, { Suspense, lazy } from "react";
import { useLanguage, useT } from "@/lib/LanguageContext";
import { fmtDayMonth, fmtMonthYear } from "../format";
import useCrmMoney from "../hooks/useCrmMoney";
import CrmCard from "../ui/CrmCard";
import { CHART_COLORS } from "../theme/states";
import ChartLegend from "../ui/charts/ChartLegend";
import { CRM } from "../../../constants/testIds/crm";

const CrmLineChart = lazy(() => import("../ui/charts/CrmLineChart"));

/** "Sales over time" — courses, products and sessions as three lines (spec). */
export default function SalesChart({ data }) {
  const t = useT("crm");
  const { lang } = useLanguage();
  const money = useCrmMoney();
  const monthly = data.period?.bucket === "month";
  const formatX = (v) => (monthly ? fmtMonthYear(v, lang) : fmtDayMonth(v, lang));
  const series = [
    { key: "courses_cents", label: t("perf.seriesCourses"), color: CHART_COLORS.ink, dot: "bg-eh-ink" },
    { key: "products_cents", label: t("perf.seriesProducts"), color: CHART_COLORS.sage, dot: "bg-eh-sage-deep" },
    { key: "sessions_cents", label: t("perf.seriesSessions"), color: CHART_COLORS.ochre, dot: "bg-eh-ochre" },
  ];
  return (
    <CrmCard data-testid={CRM.perfSales}>
      <h3 className="font-display text-xl text-eh-ink">{t("perf.salesTitle")}</h3>
      <Suspense fallback={<div className="h-[180px]" aria-busy="true" />}>
        <CrmLineChart data={data.sales_over_time || []} series={series} formatX={formatX}
          formatY={(v) => money(v, data.currency)} label={t("perf.salesTitle")} />
      </Suspense>
      <ChartLegend items={series.map((s) => ({ key: s.key, label: s.label, colorClass: s.dot }))} />
    </CrmCard>
  );
}
